// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bijyphjgqkqmsrzhiqin.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJpanlwaGpncWtxbXNyemhpcWluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY5NzM0NzgsImV4cCI6MjA3MjU0OTQ3OH0.czywyXp5yKeuSSRd96cj9RnTkkOGRm8TihvlP_y7iM4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});